@if (hideNavMenu) {
  <app-nav-menu></app-nav-menu>
}
<main class="main">
  <div class="container cms_main fadeInUp animated">
    <div class="inner_body">
      <div class="row_card ">
        <div class="cms_card-headings">Revenue Management List</div>
        <!--<a class="card-icon" (click)="AddNew()">
        <i class="uil uil-file-plus-alt card_custom-icon"></i>Add New
      </a>-->
      @if (canEditOrAddRevenue) {
        <label class="dropdown">
          <span class="dd-button button-87">
            Add New <i class="fas fa-angle-down" style="margin-left: 6px;" aria-hidden="true"></i>
          </span>
          <input type="checkbox" class="dd-input" id="test">
          <ul class="dd-menu">
            <li [routerLink]="['/GroupRevenueReport']">Add Groups</li>
            <li (click)="addnew('Ticket')">Ticket Issue Revenue</li>
            <li (click)="addnew('Void')">Void Revenue</li>
            <li (click)="addnew('Refund')">Refund Revenue</li>
            @if (tktPnrRight.importPNR) {
              <li (click)="addnew('ImportPNR')">Import PNR Revenue</li>
            }
          </ul>
        </label>
      }
    </div>
    <div class="row cms_tabel">
      <div class="col-sm-12">
        <!--[height]="'620px'"-->
        <dx-data-grid #revenueGrid
          [dataSource]="revenueManagerList"
          [showBorders]="true"
          [showRowLines]="true"
          (onCellPrepared)="onCellPrepared($event)"
          (onContentReady)="contentReady($event)"
          (onCellHoverChanged)="onCellHoverChanged($event)"
          [columnAutoWidth]="true">
          <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
          <dxo-paging [pageSize]="15"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true"
          [allowedPageSizes]="[50, 100]"></dxo-pager>
          <dxi-column [visible]="false" dataField="revenueId" alignment="center"></dxi-column>
          <dxi-column caption="Revenue Type" dataField="requestType" alignment="center"></dxi-column>
          <dxi-column [visible]="false" dataField="requestTypeID" alignment="center"></dxi-column>
          <dxi-column dataField="name" alignment="center"></dxi-column>
          <dxi-column dataField="type" alignment="center"></dxi-column>
          <dxi-column dataField="appliesOn" alignment="center"></dxi-column>
          <dxi-column dataField="agencyBranchList" width="120" alignment="center" dataType="string" caption="Agency/Branch"></dxi-column>

          <dxi-column dataField="status" alignment="center" cellTemplate="cellTemplate" caption="Status"></dxi-column>
          <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate" [width]="180"></dxi-column>
          <dxo-search-panel [visible]="true"></dxo-search-panel>

          <div *dxTemplate="let data of 'actionCellTemplate'" class="action-buttons">
            <!-- View button: always visible -->
            @if (!canEditOrAddRevenue) {
              <button class="btn action-btn view-btn" (click)="Edit_Click(data.data)">
                <i class="uil uil-eye"></i> View
              </button>
            }

            <!-- Edit button: only if user can edit -->
            @if (canEditOrAddRevenue) {
              <button class="btn action-btn edit-btn" (click)="Edit_Click(data.data)">
                <i class="uil uil-edit"></i> Edit
              </button>
            }

            <!--Delete button: only if user can edit-->
            @if (canEditOrAddRevenue) {
              <button class="btn action-btn delete-btn" (click)="DeleteRevenue(data.data.revenueId)">
                <i class="uil uil-trash-alt"></i> Delete
              </button>
            }
            <!--<button *ngIf="canEditOrAddRevenue"
            class="btn action-btn delete-btn"
            (click)="DeleteRevenue(data.data.revenueId); $event.stopPropagation()">-->
            <!--<i class="fas fa-delete-icon" style="cursor: pointer; color: red" (click)="DeleteRevenue(data.data.revenueId)"></i>-->
            <!--<i class="uil uil-trash-alt"></i> Delete-->
          <!--</button>-->
        </div>
        <div *dxTemplate="let data of 'cellTemplate'">
          <div class="custom_margin">
            <label class="switch">
              <input type="checkbox" (change)="statusSave(data.data.status,data.data.revenueId)" [(ngModel)]="data.data.status" [disabled]="!canEditOrAddRevenue">
              <span></span>
            </label>
          </div>
        </div>
      </dx-data-grid>
      <dx-popover [(target)]="popoverTarget"
        [width]="200">
        <div *dxTemplate="let data of 'content'">
          <span>{{popOverText}}</span>
        </div>
      </dx-popover>
    </div>
  </div>
</div>
</div>
@if (showDeleteModal) {
  <div class="custom-modal-backdrop">
    <div class="custom-modal">
      <div class="modal-header">
        <h3>Delete Confirmation</h3>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this revenue?</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-delete" (click)="confirmDelete()">
          Delete
        </button>
        <button class="btn btn-cancel" (click)="cancelDelete()">
          Cancel
        </button>
      </div>
    </div>
  </div>
}
</main>
